import React from "react";
import { Link } from "react-router-dom";
import ReactGA from "react-ga4";
import { useTranslation } from "react-i18next";

// Service cards for a spa, shared by both designs: the spa page renders them
// directly when the spa has no categories, and the category page renders the
// services of the selected category.
function SpaServicesList({
  services,
  room_uuid,
  spa_uuid,
  category_id,
  theme,
}) {
  const { t } = useTranslation();

  const query = [
    theme ? "theme=true" : null,
    category_id ? `category_id=${category_id}` : null,
  ]
    .filter(Boolean)
    .join("&");

  return (
    <>
      {services?.map(({ image, name, id }) => {
        return (
          <div key={id} className="add-post-container add-cart">
            <div className="add-cart-post new spa ">
              <div className="">
                <Link
                  to={`/${room_uuid}/spa/${spa_uuid}/service/${id}${
                    query ? `?${query}` : ""
                  }`}
                  state={id}
                  onClick={() => {
                    ReactGA.event({
                      category: "Open SPA card",
                      action: "Click",
                      value: `SPA: ${name}`,
                    });
                  }}
                  className="add-cart-post-inner"
                >
                  <span className="img-pnl navigate">
                    <img src={image} alt="Post" />
                  </span>
                  <div className="txt-pnl navigate">
                    <h2>{name}</h2>
                    <p></p>
                    <div
                      className="flex-div align-item-center"
                      style={theme ? { justifyContent: "flex-end" } : undefined}
                    >
                      <span className="reg-btn service">
                        {t("Add Service")}
                      </span>
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        );
      })}
    </>
  );
}

export default SpaServicesList;
